// Same as InstantSearch's __position (1-based, counted across pages), which useTypesenseGtmEvents sends with click_hit.
export const addHitPositions = <Hit extends object>(hits: Hit[], offset = 0): (Hit & { __position: number })[] =>
  hits.map((hit, index) => ({ ...hit, __position: offset + index + 1 }));
